var exports = {
  "v": "HomeView__Ja9074",
  "W": "HomeView--palette__PcjAAn",
};

module.exports = exports;
